// extracted by mini-css-extract-plugin
module.exports = {"card":"clinical-portal-3__Card__card","overflowHidden":"clinical-portal-3__Card__overflowHidden"};